"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

var Svg16VehicleWalk = function Svg16VehicleWalk(_ref) {
  var fill = _ref.fill,
      useDefaultColors = _ref.useDefaultColors,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["fill", "useDefaultColors", "title"]);

  return _react.default.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: useDefaultColors ? 'none' : fill,
    "aria-hidden": title === null || typeof title !== 'string' || title.length === 0
  }, props), _react.default.createElement("title", null, title), _react.default.createElement("path", {
    d: "M13 7.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3zM10.623 10.678l-1.273.546-.38 1.518a1 1 0 1 1-1.94-.485l.4-1.598a1.833 1.833 0 0 1 1.056-1.241l2.601-1.115a1.833 1.833 0 0 1 2.02.389l1.485 1.486 1.855.928a1 1 0 1 1-.894 1.788l-1.88-.94a1.833 1.833 0 0 1-.476-.343l-.591-.591-.444 1.553 2.092 1.395c.422.28.708.724.792 1.224l.44 2.644a1 1 0 1 1-1.972.328l-.43-2.572-2.133-1.423a1.833 1.833 0 0 1-.745-2.029l.417-1.462z",
    fill: useDefaultColors ? '#191919' : fill
  }), _react.default.createElement("path", {
    d: "M10.447 14.606a1 1 0 0 1 .447 1.341l-.605 1.211L8.1 18.8a1 1 0 1 1-1.2-1.6l1.811-1.358.395-.79a1 1 0 0 1 1.341-.446z",
    fill: useDefaultColors ? '#191919' : fill
  }));
};

Svg16VehicleWalk.propTypes = {
  title: _propTypes.default.string,
  fill: _propTypes.default.string,
  useDefaultColors: _propTypes.default.bool
};
var _default = Svg16VehicleWalk;
exports.default = _default;